'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

/**
 * Next.js's built-in scroll-to-top on navigation doesn't reliably fire once a
 * route streams its content in behind a loading.tsx boundary — the shop
 * layout uses one, so navigating away from a page scrolled far down could
 * land on the new page still scrolled to the old position. Force it.
 */
export default function ScrollRestoration() {
    const pathname = usePathname();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}
